<div class="sub-project-type" [ngClass]="subProject.typeClass">
  {{ subProject.typeDisplay }}
</div>

<ng-container *ngIf="subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT">
  <ng-container
    *ngTemplateOutlet="baseProject; context: { subProject: subProject }"
  >
  </ng-container>
</ng-container>

<ng-container *ngIf="subProject.type !== SUB_PROJECT_TYPES.BASE_PROJECT">
  <ng-container
    *ngTemplateOutlet="adjustment; context: { subProject: subProject }"
  >
  </ng-container>
</ng-container>

<ng-template #baseProject let-subProject="subProject">
  <div class="sub-project-detail">
    <ng-container *ngIf="subProject.products?.length > 0">
      <div class="product-detail">
        <div class="placement-image-container">
          <div
            class="placement-image"
            [class.clickable]="subProject.products[0].lightboxAlbum?.length > 0"
            [ngStyle]="backgroundImageStyle != null ? backgroundImageStyle : {}"
            (click)="openAlbum(subProject.products[0].lightboxAlbum)"
          ></div>
        </div>
        <hr />
        <div class="sub-project-info">
          <span class="click-link" (click)="openProject()"
            >#{{ subProject.projectId }}</span
          >
          <span
            *ngIf="subProject.oldPlatformId != null"
            class="font-weight-bold font-italic"
            [matTooltip]="'Jobnummer oud platform'"
          >
            ({{ subProject.oldPlatformId }})</span
          >
        </div>
        <div class="sub-project-info">
          {{ subProject.executionDate | formatDate }}
        </div>
        <div class="sub-project-info-with-placer">
          <div>
            <ng-container
              *ngTemplateOutlet="
                placer;
                context: { placer: subProject.firstPlacer }
              "
            ></ng-container>
            <span>
              {{
                subProject.products[0].typeDisplay
                  | shortenText: 25
                  | joiner: ' - ':subProject.products[0].formatDisplay
              }}
            </span>
          </div>
        </div>
        <div class="sub-project-info">
          {{
            subProject.address?.line1
              | printAddress
                : subProject.address?.postalCode
                : subProject.address?.city
          }}
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #adjustment let-subProject="subProject">
  <div class="sub-project-detail">
    <div class="placement-image-container">
      <div
        class="placement-image"
        [class.clickable]="
          subProject.type === SUB_PROJECT_TYPES.REPO
            ? subProject.products[0].lightboxAlbum?.length > 0
            : subProject.lightboxAlbum?.length > 0
        "
        [ngStyle]="backgroundImageStyle != null ? backgroundImageStyle : {}"
        (click)="
          openAlbum(
            subProject.type === SUB_PROJECT_TYPES.REPO
              ? subProject.products[0].lightboxAlbum
              : subProject.lightboxAlbum
          )
        "
      ></div>
    </div>
    <hr />
    <div class="sub-project-info">
      <span class="click-link" (click)="openProject()"
        >#{{ subProject.projectId }}</span
      >
      <span *ngIf="subProject.customerDisplay?.length > 0">
        - {{ subProject.customerDisplay }}</span
      >
    </div>
    <div class="sub-project-info">
      {{ subProject.executionDate | formatDate }}
    </div>
    <div
      *ngFor="let product of subProject.products; let first = first"
      class="d-flex sub-project-info-with-placer"
    >
      <div>
        <ng-container *ngIf="first">
          <ng-container
            *ngTemplateOutlet="
              placer;
              context: { placer: subProject.firstPlacer }
            "
          ></ng-container>
        </ng-container>
        <span>
          {{
            product.typeDisplay
              | shortenText: 25
              | joiner: ' - ':product.formatDisplay
          }}
        </span>
      </div>
    </div>
    <div class="sub-project-info">
      {{
        subProject.address?.line1
          | printAddress
            : subProject.address?.postalCode
            : subProject.address?.city
      }}
    </div>
  </div>
</ng-template>

<ng-template #placer let-placer="placer">
  <div
    *ngIf="placer != null"
    class="employee-initials in-the-middle display-inline rounded-circle"
    [matTooltip]="placer.user?.firstName | personName: placer.user?.lastName"
  >
    <span *ngIf="!placer.user?.profilePicture">
      {{ placer.user?.firstName | initials: placer.user?.lastName }}
    </span>
    <span *ngIf="placer.user?.profilePicture">
      <img
        class="rounded-circle"
        width="20px"
        height="20px"
        [src]="'/api/assets/' + placer.user?.profilePicture?.uuid + '/20'"
      />
    </span>
  </div>
</ng-template>
